import { render, staticRenderFns } from "./registration-tab-header.vue?vue&type=template&id=9c2e84da&"
import script from "./registration-tab-header.vue?vue&type=script&lang=js&"
export * from "./registration-tab-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c2e84da')) {
      api.createRecord('9c2e84da', component.options)
    } else {
      api.reload('9c2e84da', component.options)
    }
    module.hot.accept("./registration-tab-header.vue?vue&type=template&id=9c2e84da&", function () {
      api.rerender('9c2e84da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/parts/registration-tab-header.vue"
export default component.exports